/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BodySaveStep3ApiOnboardingStep3PostAccessLevel = typeof BodySaveStep3ApiOnboardingStep3PostAccessLevel[keyof typeof BodySaveStep3ApiOnboardingStep3PostAccessLevel];


export const BodySaveStep3ApiOnboardingStep3PostAccessLevel = {
  private: 'private',
  shared: 'shared',
} as const;
